import { CUSTOM_ELEMENTS_SCHEMA, inject, LOCALE_ID, NgModule } from '@angular/core';
import { BrowserModule, Title } from '@angular/platform-browser';
import { RouteReuseStrategy } from '@angular/router';

import { IonicModule, IonicRouteStrategy } from '@ionic/angular';

import { AppComponent } from './app.component';
import { AppRoutingModule } from './app-routing.module';
import { StoreModule } from '@ngrx/store';
import { metaReducers, reducers } from './reducers';
import { EffectsModule } from '@ngrx/effects';
import { AppEffects } from './app.effects';
import { HTTP_INTERCEPTORS, HttpClient, HttpClientModule } from '@angular/common/http';
import { WebsocketEffects } from './websocket.effects';
import localeDeDe from '@angular/common/locales/de';
import { registerLocaleData } from '@angular/common';
import { SettingsModule } from '@orga-app/settings';
import { FunktionsbereichsauswahlPageModule } from './verwaltung/funktionsbereichsauswahl/funktionsbereichsauswahl.module';
import { FunktionsbereichEntfernenPageModule } from './verwaltung/funktionsbereich-entfernen/funktionsbereich-entfernen.module';
import { SopiScrollModule } from '../sopi/components/sopi-scroll/sopi-scroll.module';
import { ChecklisteEntfernenPageModule } from './verwaltung/checkliste-entfernen/checkliste-entfernen.module';
import { ChecklistenauswahlPageModule } from './verwaltung/checklistenauswahl/checklistenauswahl.module';
import { BenutzerauswahlPageModule } from './verwaltung/benutzerauswahl/benutzerauswahl.module';
import { FunktionsbereichLoeschenPageModule } from './verwaltung/funktionsbereich-loeschen/funktionsbereich-loeschen.module';
import { AufgabePageModule } from './verwaltung/aufgabe/aufgabe.module';
import { SopiComponentsModule } from './shared/sopi-components/sopi-components.module';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { VeranstaltungLoeschenPageModule } from './verwaltung/veranstaltung-loeschen/veranstaltung-loeschen.module';
import { ChecklisteLoeschenPageModule } from './verwaltung/checkliste-loeschen/checkliste-loeschen.module';
import { ModalDokumentLoeschenPageModule } from './verwaltung/dokumentverwaltung/modal-dokument-loeschen/modal-dokument-loeschen.module';
import { environment } from '../environments/environment';
import { WebsocketModule } from '@orga-app/websocket';
import { WebsocketInitEffects } from './websocket.init.effects';
import { NaviModule } from './navi/navi.module';
import { AppStateModule } from './operativ/app-state/app.state.modules';
import { VeranstaltungKopierenPageModule } from './verwaltung/veranstaltung-kopieren/veranstaltung-kopieren.module';
import { TranslateLoader, TranslateModule } from '@ngx-translate/core';
import { JsonEditorPageModule } from './mandantenverwaltung/modale/json-editor/json-editor.module';
import { HinweisMeldungPageModule } from './shared/hinweis-meldung/hinweis-meldung.module';
import { BenutzerverwaltungBenutzerInfoEffects } from '../client-ngrx/benutzerverwaltung';
import { MarkdownModule } from 'ngx-markdown';
import { DragDropModule } from '@angular/cdk/drag-drop';
import { RollenselektionPageModule } from './verwaltung/rollenselektion/rollenselektion.module';

import { AufgabebemerkungPageModule } from './operativ/aufgabebemerkung/aufgabebemerkung.module';
import { FehlerbeschreibungPageModule } from './operativ/fehlerbeschreibung/fehlerbeschreibung.module';
import { BildVorschauModule } from '../sopi/components/bild-vorschau/bild-vorschau.module';
import { MandantModule } from '@orga-app/mandant';
import { ClientsModule } from '@orga-app/clients';
import { MandantRoutingModule } from './mandant/mandant-routing.module';
import { MyModule } from '@orga-app/providers';
import { EnvModule } from '@orga-app/env/env-module';
import { HomeComponent } from './home/home.component';
import { AppEffectsDesktopClient } from './app.effects-desktop-client';
import { NeuenIncidentPageModule } from './operativ/incident/incident.module';
import { ImpressumPageModule } from './impressum/impressum.module';
import { PipesModule } from '../sopi/pipes/pipes.module';
import { FeldOptionPageModule } from './mandantenverwaltung/modale/feld-option/feld-option.module';
import { ApiMandantClearCacheEffects } from '../client-ngrx/api';
import { DisplaysteuerungPageModule } from './verwaltung/displaysteuerung/displaysteuerung.module';
import { TriggerauswahlPageModule } from './verwaltung/displaysteuerung/triggerauswahl/triggerauswahl.module';
import { QschecksControllingFilterPageModule } from './controlling/qschecks/qschecks-controlling-filter/qschecks-controlling-filter.module';
import { VeranstaltungstypAuswahlPageModule } from './modale/veranstaltungstyp-auswahl/veranstaltungstyp-auswahl.module';
import { AufgabenBerechtigungenModalModule } from './verwaltung/aufgaben-berechtigungen/aufgaben-berechtigungen-modal/aufgaben-berechtigungen-modal.module';
import { RolleLoeschenPageModule } from './verwaltung/rolle-loeschen/rolle-loeschen.module';
import { VeranstaltungselektionPageModule } from './operativ/veranstaltungsselection/veranstaltungselektion.module';
import { VorlageAuswaehlenPageModule } from './operativ/incident/vorlage-auswaehlen/vorlage-auswaehlen.module';
import { MultiTranslateHttpLoader } from './multi-translate-http-loader';
import { InstrumentationModule } from '@orga-app/instrumentation';
import { HankoModule, OnSuccessFn } from 'src/sopi/hanko';
import { HankoLoginPage } from '../sopi/hanko-login-page/hanko-login.page';
import { AuthModule, AuthTypes } from '@orga-app/auth';
import { FormsModule } from '@angular/forms';
import { loginSucceessFn } from './app.login-success';
import { CancelRequestsInterceptor } from '@orga-app/providers/cancel-request.interceptor';



export function HttpLoaderFactory(http: HttpClient) {
    return new MultiTranslateHttpLoader(http, [
        { prefix: './assets/i18n/', suffix: '.json' },
        { prefix: './assets/i18n/update/', suffix: '.json' },
    ]);
}

registerLocaleData(localeDeDe);

@NgModule({
    declarations: [AppComponent, HomeComponent, HankoLoginPage],
    imports: [
        EnvModule.forRoot(environment),
        BrowserModule,
        HttpClientModule,
        BrowserAnimationsModule,
        DragDropModule,
        IonicModule.forRoot({
            mode: 'md',
            animated: true
        }),

        AppRoutingModule,
        HankoModule.forRoot({
            hankoUrl: environment.hankoUrl,
            apiUrl: environment.appConfig.apiUrl,
            loginCheckApiUrl: 'api/account/logincheck',
            logoutApiUrl: 'api/account/logout',
            loginRoute: environment.loginRoute,
            successFn: loginSucceessFn
            // postLoginRoute: '/'
        }),

        AuthModule.forRoot({
            loginRoute: environment.loginRoute,
            azureAd: environment.azureAd,
            debug: environment.debug,
            type: AuthTypes.aad2,
            redirectUri: environment.homeRoute,
            redirectUriFromOrigin: true,
            tenantMappings: environment.azureAd.tenantMappings
        }),

        AppStateModule.forRoot(),
        MandantModule.forRoot(environment.appConfig.apiUrl, 'mandanten-auswahl'),
        MyModule.forRoot(environment.appConfig.apiUrl),
        WebsocketModule.forRoot(environment.appConfig.wsEndpoint),
        ClientsModule.forRoot(environment.appConfig.apiUrl),

        SopiComponentsModule.forRoot(),

        SettingsModule.forRoot(environment.appConfig.themeUrl, environment.appConfig.themeType),
        SopiScrollModule,
        MarkdownModule.forRoot(),
        StoreModule.forRoot(reducers, {
            metaReducers,
            runtimeChecks: {
                strictStateImmutability: true,
                strictActionImmutability: true
            }
        }),

        EffectsModule.forRoot([
            AppEffects,
            AppEffectsDesktopClient,
            WebsocketInitEffects,
            WebsocketEffects,
            BenutzerverwaltungBenutzerInfoEffects,
            ApiMandantClearCacheEffects
        ]),
        TranslateModule.forRoot({
            loader: {
                provide: TranslateLoader,
                useFactory: (HttpLoaderFactory),
                deps: [HttpClient]
            }
        }),
        InstrumentationModule.forRoot({
            applicationInsightsConnectionString: environment.appConfig.appInsightsConnectionString,
            appId: 'mobile-client',
            appVersion: environment.version,
        }),
        NaviModule.forRoot(),
        FormsModule,

        MandantRoutingModule,

        // Modale
        FunktionsbereichsauswahlPageModule.forRoot(),
        FunktionsbereichEntfernenPageModule.forRoot(),
        FunktionsbereichLoeschenPageModule.forRoot(),
        ChecklisteEntfernenPageModule.forRoot(),
        ChecklistenauswahlPageModule.forRoot(),
        ChecklisteLoeschenPageModule.forRoot(),
        BenutzerauswahlPageModule.forRoot(),
        AufgabePageModule.forRoot(),
        VeranstaltungLoeschenPageModule.forRoot(),
        VeranstaltungKopierenPageModule.forRoot(),
        ModalDokumentLoeschenPageModule.forRoot(),
        JsonEditorPageModule.forRoot(),
        FeldOptionPageModule.forRoot(),
        HinweisMeldungPageModule.forRoot(),
        RollenselektionPageModule.forRoot(),
        RolleLoeschenPageModule.forRoot(),
        AufgabebemerkungPageModule.forRoot(),
        FehlerbeschreibungPageModule.forRoot(),
        BildVorschauModule.forRoot(),
        NeuenIncidentPageModule.forRoot(),
        ImpressumPageModule.forRoot(),
        DisplaysteuerungPageModule.forRoot(),
        TriggerauswahlPageModule.forRoot(),
        QschecksControllingFilterPageModule.forRoot(),
        VeranstaltungstypAuswahlPageModule.forRoot(),
        AufgabenBerechtigungenModalModule.forRoot(),
        VeranstaltungselektionPageModule.forRoot(),
        VorlageAuswaehlenPageModule.forRoot(),
        PipesModule,

    ],
    providers: [
        { provide: RouteReuseStrategy, useClass: IonicRouteStrategy },
        { provide: LOCALE_ID, useValue: 'de-DE' },
        Title,
        {
            provide: HTTP_INTERCEPTORS,
            useClass: CancelRequestsInterceptor,
            multi: true
        },
    ],
    bootstrap: [AppComponent],
    schemas: [CUSTOM_ELEMENTS_SCHEMA]
})
export class AppModule {
}
